

const SetThickness = (LoadedModel) => ({
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, elem, attrs, ctrl) {
        elem.on("keyup", function(ev) {
            if (ev.keyCode === 13 && LoadedModel.thickness !== elem.val()) {
                LoadedModel.invalidateThickness();
                scope.$apply();
            }
        });
    }
});

SetThickness.$inject = ['LoadedModel'];

const setThicknessModule = angular.module('SetThickness', [])
  .directive('setThickness', SetThickness)
  .name;



export default setThicknessModule





// WEBPACK FOOTER //
// ./client/app/common/services/set-thickness-directive.js